import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Bulto } from "src/app/models/Dte/Exportacion/Bulto";
import { CodigosAduana } from "src/app/models/Dte/Exportacion/CodigosAduana";
import { TipoBulto } from "src/app/models/Dte/Exportacion/TipoBulto";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Component({
	selector: "app-packages-list",
	templateUrl: "./packages-list.component.html",
	styleUrls: ["./packages-list.component.scss"],
})
export class PackagesListComponent implements OnInit {
	public packagesForm: FormGroup;
	public packagesArray: FormArray;
	private bultoItemFormGroup: FormGroup;
	private packagesList: Bulto[] = [];
	public codigoTipoBultoSource: TipoBulto[] = [];
	private codigosAduana: CodigosAduana;
	@Output() packageListEmitter: EventEmitter<any> = new EventEmitter<any>();
	constructor(private formBuilder: FormBuilder, private localStorage: LocalStorageService) {}

	ngOnInit(): void {
		this.codigosAduana = this.localStorage.getCodigosAduana();
		this.codigoTipoBultoSource = this.codigosAduana.tipoBultos;
		this.sortAlphabeth(this.codigoTipoBultoSource, "descripcion");
		this.setArray();
	}

	setArray() {
		this.packagesForm = this.formBuilder.group({
			packsArray: this.formBuilder.array([this.newPackageForm()]),
		});
	}

	newPackageForm(): FormGroup {
		return this.formBuilder.group({
			codigotipoBulto: [, Validators.required],
			cantidadBulto: [, Validators.required],
			marcas: [],
			idContainer: [],
			sello: [],
			emisorSello: [],
		});
	}

	addPackageForm() {
		const currentArray = this.packagesForm.controls.packsArray as FormArray;
		if (currentArray.length < 10) {
			let newPackageForm = this.newPackageForm();
			currentArray.push(newPackageForm);
		}
	}

	removePackageForm(i) {
		const currentArray = this.packagesForm.controls.packsArray as FormArray;
		if (currentArray.length > 1) {
			currentArray.removeAt(i);
		} else {
			currentArray.reset();
		}
		this.submit();
	}

	submit() {
		const currentArray = this.packagesForm.controls.packsArray as FormArray;
		if (this.packagesForm.valid) {
			this.packagesList = [];
			currentArray.controls.forEach((formGroupItem, index) => {
				let exportPackage = new Bulto();
				let tipoBulto: TipoBulto = (formGroupItem as FormGroup).controls.codigotipoBulto.value;
				exportPackage.codigoTipoBulto = tipoBulto.codigoSii;
				exportPackage.tipoBultoId = tipoBulto.tipoBultoId;
				exportPackage.nombreTipoBulto = tipoBulto.descripcion;
				exportPackage.cantidadBultos = (formGroupItem as FormGroup).controls.cantidadBulto.value;
				exportPackage.marcas = (formGroupItem as FormGroup).controls.marcas.value;
				exportPackage.idContainer = (formGroupItem as FormGroup).controls.idContainer.value;
				exportPackage.sello = (formGroupItem as FormGroup).controls.sello.value;
				exportPackage.emisorSello = (formGroupItem as FormGroup).controls.emisorSello.value;
				exportPackage.localIndex = index + 1;
				this.packagesList.push(exportPackage);
			});
			this.packageListEmitter.emit(this.packagesList);
		} 
	}

	sortAlphabeth(list: any[], propertyName: string) {
		list.sort(function (a, b) {
			return a[propertyName].localeCompare(b[propertyName]);
		});
	}
}
